// extracted by mini-css-extract-plugin
export var sliderRange = "_q5-2";
export var sliderRoot = "_q5-0";
export var sliderThumb = "_q5-3";
export var sliderTrack = "_q5-1";